import { RootStoreModel, ActiveProcessStoreModel } from '../store.model'

/**
 * Selecciona todos los procesos activos
 */
export const selectActiveProcesses = (state: RootStoreModel): ActiveProcessStoreModel[] => {
  if (!state.processing?.activeProcesses) {
    return []
  }
  return Object.values(state.processing.activeProcesses)
}

/**
 * Selecciona un proceso específico por ID
 */
export const selectProcessById = (
  state: RootStoreModel,
  processId: string
): ActiveProcessStoreModel | undefined => {
  return state.processing?.activeProcesses?.[processId]
}

/**
 * Verifica si hay algún proceso activo
 */
export const selectHasActiveProcesses = (state: RootStoreModel): boolean => {
  return selectActiveProcesses(state).length > 0
}

/**
 * Cuenta el número de procesos activos
 */
export const selectActiveProcessesCount = (state: RootStoreModel): number => {
  return selectActiveProcesses(state).length
}
